import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'ui-shared';

@Injectable({
  providedIn: 'root'
})
export class CatalogoConfigAuthGuard  {
  constructor(
    @Inject(Router) private router: Router,
    @Inject(LoginService) private loginService: LoginService
  ) { }

  canActivate = () => (this.loginService.estaLogado() && this.loginService.suporte) || this.router.navigate(['home']);

}
